<template>
  <v-container fluid>
    <v-row>
<!--      {{details}}-->

      <v-col v-for="(detail, index) in details" :key="index" cols="12" md="3">
        <v-card outlined tile>

          <v-list-item>
            <v-list-item-avatar tile size="45">
              <v-icon v-if="detail.status === 1" color="blue" style="font-size: 45px;">mdi-file</v-icon>
              <v-icon v-else-if="detail.status === 77" color="blue" style="font-size: 45px;">mdi-hiking</v-icon>
              <v-icon v-else-if="detail.status === 67" color="blue" style="font-size: 45px;">mdi-star</v-icon>
            </v-list-item-avatar>

            <v-list-item-content class="ml-1">
              <v-list-item-subtitle>{{ getStatusText(detail.status) }}</v-list-item-subtitle>
              <v-list-item-title class="text-h6">{{ detail.total_npr }}</v-list-item-title>
              <v-list-item-title class="text-right">
                <span class="text-caption primary--text text--darken-1">Total Rows:</span>
                <span class="text-h6  primary--text ml-1">{{ detail.total_count }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card outlined tile>
          <v-list-item>
            <v-list-item-avatar tile size="45">
              <v-icon color="blue" style="font-size: 50px;">mdi-cash</v-icon>
            </v-list-item-avatar>

            <v-list-item-content class="ml-1">
              <v-list-item-subtitle>Total</v-list-item-subtitle>
              <v-list-item-title class="text-h6"> {{grandTotalNpr}}</v-list-item-title>
              <v-list-item-title class="text-right">
                <span class="text-caption primary--text text--darken-1">Total Rows:</span>
                <span class="text-h6  primary--text ml-1">{{ grandTotalCount }}</span>
              </v-list-item-title>

            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>

    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>

        <h3 class="font-weight-bold">Overall Revenue Report ({{filters.date_range.start}} - {{filters.date_range.end}} ) - {{user.office_name}}</h3>
        <div>

                    <span class="mr-2">
                        <sidebar-filter-button>
                            <v-layout row wrap class="ml-2 mr-2">
<!--                              <v-flex xs12 class="mb-4">-->
<!--                                 <v-text-field-->
<!--                                     class="hidden-sm-and-down"-->
<!--                                     outlined-->
<!--                                     hide-details-->
<!--                                     placeholder="Search by voucher/invoice number"-->
<!--                                     prepend-inner-icon="search"-->
<!--                                     v-model="filters.voucher_invoice_number"-->
<!--                                     @keypress.enter="filterFn"-->
<!--                                 />-->
<!--                                </v-flex>-->
                                <v-flex xs12 class="mb-4">
                                   <custom-date-range-picker
                                       @change="filterFn"
                                       v-model="filters.date_range"
                                       :outlined="true"
                                   />
                                </v-flex>

                              <!--                                <v-flex xs12 class="mb-4">-->
                              <!--                                    <v-autocomplete-->
                              <!--                                        :items="revenueTypes"-->
                              <!--                                        chips-->
                              <!--                                        clearable-->
                              <!--                                        deletable-chips-->
                              <!--                                        flat-->
                              <!--                                        outlined-->
                              <!--                                        hide-details-->
                              <!--                                        item-text="label"-->
                              <!--                                        item-value="value"-->
                              <!--                                        label="Revenue Type"-->
                              <!--                                        multiple-->
                              <!--                                        prepend-inner-icon="filter_list"-->
                              <!--                                        solo-->
                              <!--                                        v-model="filters.revenueType"-->
                              <!--                                        @change="fetchFiltersData"-->
                              <!--                                    />-->
                              <!--                                </v-flex>-->
<!--                                <v-flex xs12 class="mb-4">-->
<!--                                      <v-autocomplete-->
<!--                                          :items="offices"-->
<!--                                          chips-->
<!--                                          clearable-->
<!--                                          deletable-chips-->
<!--                                          flat-->
<!--                                          outlined-->
<!--                                          hide-details-->
<!--                                          item-text="name"-->
<!--                                          item-value="id"-->
<!--                                          label="Filter By Office"-->
<!--                                          multiple-->
<!--                                          @change="fetchFiltersData"-->
<!--                                          prepend-inner-icon="filter_list"-->
<!--                                          solo-->
<!--                                          v-model="filters.officeId"-->
<!--                                      />-->
<!--                                </v-flex>-->
                            </v-layout>

                        </sidebar-filter-button>
                    </span>
          <export-excel-button :export-data="exportData"
                               v-if="$oauth.checkIfHasPermission(['export revenue-report'])"/>
          <refresh-button :click-function="refreshData"></refresh-button>
        </div>
      </v-flex>
      <v-flex lg12>
        <v-card>
          <v-card-text class="pa-0">
            <v-data-table
                :headers="headers"
                :items="data"
                :loading="loading"
                :options.sync="pagination"
                :footer-props="footerProps"
                class="elevation-0"
                v-if="$oauth.checkIfHasPermission(['read revenue-report'])"
                hide-default-footer
            >
            </v-data-table>
            <issued-visa-footer @nextClick="handleNextClick" @prevClick="handlePrevClick"
                                :disable-next="disableNext"
                                :disable-prev="disablePrev"
                                :perPage="pagination.itemsPerPage"
                                @rowChanged="fetchDataWithRow"
                                @getCount="getCount"
                                :total="total"
                                :items-loading="totalItemsLoading"
                                :showing-of="showingOf"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportExcelButton from "../../components/ExportExcelButton";
import SidebarFilterButton from "../../components/SidebarFilterButton";
import RefreshButton from "@/components/RefreshButton";
import moment from "moment";
import ArrivalSvg from "../../components/svgs/ArrivalSvg.vue";
import Http from "axios";
import {
  VERSIONED_API_URL,
} from '../../config/config'
import VisaRequestSvg from "../../components/svgs/VisaRequestSvg.vue";
import DetailCardDuplicate from "../../components/cards/DetailCardDuplicate.vue";

export default {
  data() {
    return {
      filterDrawer: true,
      // details: [{total_amount: '-', status: '-'}],
      // totals: {total_amount: '-', total_npr: '-'},
      pagination: {
        itemsPerPage: 25,
        sortBy: ["created_at"],
        sortDesc: ["true"]
      },
      sources: ['Malanika', 'Manual', 'Online'],
      revenueTypes: [
        {
          label: "Visa Fee",
          value: "1"
        },
        {
          label: "Late Fine",
          value: "13"
        },
        {
          label: "Overstay Fine",
          value: "14"
        }
      ],
      title: "Revenue Report",
      headers: [
        {
          text: "S.N.",
          value: "s_no",
          sortable: false
        },
        {
          text: "Voucher Number",
          value: "voucher_number",
          sortable: false
        },
        {
          text: "Revenue Type",
          value: "status",
          sortable: false
        },
        {
          text: "Amount(USD)",
          value: "cost_usd",
          sortable: false
        },
        {
          text: "Amount(NPR)",
          value: "cost_npr",
          sortable: false
        },
        {
          text: "Office",
          value: "office",
          sortable: false
        },
        {
          text: "Date",
          value: "created_at",
          sortable: false
        },
      ],
      routeParams: null
    };
  },
  components: {
    DetailCardDuplicate, VisaRequestSvg,
    ArrivalSvg,
    RefreshButton, SidebarFilterButton, CustomDateRangePicker, IssuedVisaFooter, ExportExcelButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters("AuthUser", ["user"]),
    ...mapGetters({
      loading: "OverAllReport/reportLoading",
      visaTypes: "VisaTypeList/all",
      countries: "CountryList/all",
      offices: "OfficeList/offices",
      details: "OverAllReport/reportTotals",         // ← summary cards
      grandTotalNpr: "OverAllReport/reportGrandTotalNpr",  // ← grand total
      grandTotalCount: "OverAllReport/reportGrandTotalCount"  // ← grand total
    }),
  },
  methods: {

    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries",
      getOffices: "OfficeList/fetchData",
    }),
    view(item) {
      this.$router.push({
        name: "ViewVisaRequest",
        params: {id: item.id.toString()}
      });
    },
    refreshData(){
      this.fetchData();
    },
    // fetchTotalCount(){
    //   const link = `${VERSIONED_API_URL}/revenue-report/sum-all/report`
    //
    //   Http.get(link, {
    //     params: this.filters
    //   }).then(res=>{
    //     console.log(res)
    //     let data =res.data
    //     this.details = data.details
    //     this.totals = data.totals
    //   }).catch (error => {
    //     console.error('Error fetching total count:', error);
    //   })
    //   // const response = Http.get(link, {
    //   //   params: this.filters
    //   // });
    //
    // },
    filterFn(){
      // this.fetchTotalCount()
      this.fetchData()
    },
    getStatusText(status) {
      switch(status) {
        case 1:
          return 'Visa';
        case 67:
          return 'Special Case Payment';
        case 77:
          return 'Trekking';
        default:
          return 'Others';
      }
    }
  },
  mounted() {
    // this.fetchTotalCount()

    const today = moment().format('YYYY-MM-DD');
    this.stateName = 'OverAllReport';
    this.setFilters({date_range: {start: today, end: today}});

    this.fetchData();  // ← This triggers the API call → fills totals
    this.commonState = this.$store.state.OverAllReport;
    this.fetchCountries();

    let params = this.$route.params;
    if (params.fromRoute) {
      this.filters.source = params.source;
      this.filters.date_range = {"start": params.start_date, "end": params.end_date}
    }


    if (this.$store.state.VisaTypeList.all.length === 2) {
      this.$store.dispatch('VisaTypeList/fetchAll');
    }
    // this.fetchData()
    if (this.$store.state.OfficeList.offices.length === 0) {
      this.getOffices();
    }
  },
  watch: {
    '$route.params': function (newVal,oldVal){
      let params = newVal
      console.log(newVal)
      if (params.fromRoute) {
        let editedFilter = {};
        editedFilter.source = params.source;
        editedFilter.date_range = {"start": params.start_date, "end": params.end_date}
        this.setFilters(editedFilter)
        this.fetchData()
      }
    }
  }
};
</script>
